import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid, Typography } from "@mui/material";
import { ClientsContext } from "../context/ClientsContextProvider";
import { Client, PostClient } from "../types";
import TextInput from "../../../main/components/TextInput";
import {
  clientUserDataToClient,
  clientToClientUserData,
} from "../clientUserMapper";
import SelectUsinasTable from "../../../main/components/SelectUsinasTable";
import { emailRegex, phoneRegex } from "../../../main/utils/utils";
import PhoneNumberInput from "../../../main/components/PhoneNumberInput";

const schema = yup.object().shape({
  email: yup
    .string()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .matches(emailRegex, "Formato de email inválido")
    .required("O email do usuário é obrigatório"),
  phone: yup
    .string()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .matches(phoneRegex, "Formato de Telefone inválido"),
  usinasIds: yup.array().of(yup.string().required()).nullable(),
});

export type ClientUserData = yup.InferType<typeof schema>;

const ClientUserForm = React.forwardRef(
  (
    props: {
      selectedStep: number;
      setSelectedStep: React.Dispatch<React.SetStateAction<number>>;
    },
    ref
  ) => {
    const {
      client: client,
      setClient: setClient,
      setClientUsinasIds,
    } = useContext(ClientsContext);
    // const { isMobile } = useContext(MainContext);
    const {
      handleSubmit,
      control,
      formState: { errors },
      setValue,
      watch,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const selectedUsinasIds = watch("usinasIds");
    function updateData() {
      const data = clientToClientUserData(client);
      if (!data) return;
      setValue("email", data.email);
      setValue("phone", data.phone);
      setValue("usinasIds", data.usinasIds);
    }
    useEffect(() => {
      updateData();
    }, [client]);
    const onSubmit = async (data: ClientUserData) => {
      setClientUsinasIds(data.usinasIds ?? []);
      const clientUser = clientUserDataToClient(data);
      const newClientData: PostClient | Client = {
        ...client,
        ...clientUser,
      };
      setClient(newClientData);
      props.setSelectedStep(props.selectedStep + 1);
    };

    React.useImperativeHandle(ref, () => ({
      async submitForm() {
        await handleSubmit(onSubmit)();
      },
    }));
    return (
      <>
        <Grid
          spacing={2}
          container
          component={"form"}
          width={"100%"}
          onSubmit={handleSubmit(onSubmit)}
          paddingX={"10px"}
        >
          <Grid display={"flex"} item xs={12} md={6}>
            <TextInput
              fieldName="email"
              label="Email"
              control={control}
              errors={errors}
              sx={{
                width: "100%",
                // maxWidth: "280px",
              }}
              // sx={{
              //   marginRight: isMobile ? "" : "10px",
              //   marginBottom: isMobile ? "10px" : "0px",
              //   flex: 3,
              // }}
            />
          </Grid>
          <Grid display={"flex"} item xs={12} md={6}>
            <PhoneNumberInput
              fieldName="phone"
              label="Telefone"
              control={control}
              errors={errors}
              sx={{
                width: "100%",
                // maxWidth: "280px",
              }}
              // sx={{
              //   flex: 2,
              // }}
            />
          </Grid>
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
                marginTop: "30px",
              }}
            >
              Selecione as Usinas do cliente:
            </Typography>
          </Grid>
          <Grid display={"flex"} item xs={12} sx={{ marginBottom: "30px" }}>
            <SelectUsinasTable
              setValue={setValue}
              selectedUsinasIds={selectedUsinasIds ?? []}
            />
          </Grid>
        </Grid>
      </>
    );
  }
);

export default ClientUserForm;
